// External Plugins

// App components
import './components/fixedHeader';
import './components/offCanvasNav';
import './components/cookieConsent';
import './components/modal';
import './components/scrollAnimations';
// import './components/serviceWorkerInit';
// import './components/fontTrackingCode';
import './components/collapse';
import { initLightboxGallery } from './components/lightboxGallery';

// IE11 polyfill for external svgs
import svg4everybody from 'svg4everybody';

(function() {
	const rememberScrollPosition = function() {
		window.addEventListener('pagehide', function() {
			var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
			window.localStorage.setItem('scrollPosition', scrollPosition);
		});
	};

	const bindEvents = () => {
		// Remove o-ratio loader
		document.addEventListener('lazyloaded', e => {
			const closestHasLoaderParent = e.target.closest('.has-loader');

			if (closestHasLoaderParent) {
				closestHasLoaderParent.classList.remove('has-loader');
			}
		});

		// Remember scroll position
		const rememberScrollPosLinks = document.querySelectorAll('.js-remember-scroll-position a');

		if (rememberScrollPosLinks.length) {
			for (let i = 0; i < rememberScrollPosLinks.length; i++) {
				rememberScrollPosLinks[i].addEventListener('click', rememberScrollPosition);
			}
		}
	};

	const init = () => {
		bindEvents();

		svg4everybody();

		// Init Photoswipe
		if (document.querySelectorAll('.gallery').length) {
			initLightboxGallery('.gallery');
		}
		if (document.querySelectorAll('figure.wp-caption').length) {
			initLightboxGallery('figure.wp-caption');
		}
	};

	document.addEventListener('DOMContentLoaded', init);
})();
